import gql from 'graphql-tag';

const DELETE_COMMENT_ON_DEVICE = gql`
  mutation deleteCommentOnDevice($commentId: String!) {
    deleteCommentOnDevice(commentId: $commentId) {
      code
    }
  }
`;

export default DELETE_COMMENT_ON_DEVICE;
